


















































































import Vue from 'vue'
import FeaturedProject from '@/components/FeaturedProject.vue'
import FooterItem from '@/components/FooterItem.vue'
import HeaderPartners from '@/components/HeaderPartners.vue'
import Services from '@/components/Services.vue'
import Experiences from '@/components/Experiences.vue'
import Location from '@/components/Location.vue'
const carousel = require('v-owl-carousel')

export default Vue.extend({
  name: 'home',
  components: {
    FeaturedProject,
    FooterItem,
    HeaderPartners,
    Services,
    Experiences,
    Location,
    carousel
  },
  data: function () {
    return {
      HeaderPartners: {
        img: {
          src: 'assets/img/partners/izertis/izertis-logo.png',
          alt: 'Izertis es una consultora tecnológica que facilita la transformación digital de las organizaciones'
        },
        name: 'Izertis, S.L.',
        description: 'Izertis es una consultora tecnológica que facilita la transformación digital de las organizaciones mediante la implantación de soluciones, servicios tecnológicos y de innovación.'
      },
      services: {
        description: 'Servicios y soluciones de integración y desarrollo, consultoría y soluciones de gestión empresarial, e infraestructura y sistemas.',
        services: [
          {
            title: 'Transformación digital e innovación',
            description: 'Servicios orientados a facilitar la transformación digital de las organizaciones y la implantación de modelos digitales.'
          },
          {
            title: 'Soluciones de gestión',
            description: 'Herramientas para facilitar la gestión empresarial, el control y la toma de decisiones.'
          },
          {
            title: 'Software Factory',
            description: 'Desarrollo, mejora y mantenimiento de plataformas y aplicaciones.'
          },
          {
            title: 'Infraestructura TI',
            description: 'Despliegue, administración y mantenimiento de infraestructuras físicas, híbridas y cloud.'
          },
          {
            title: 'Business Operations',
            description: 'Gestión de recursos especializados en transformación digital, IT y consultoría (staffing).'
          },
          {
            title: 'Digital Services',
            description: 'Desarrollo de estrategias online orientadas a la generación de negocio meidante el uso de técnicas de marketing.'
          },
          {
            title: 'Proyectos y gobierno IT',
            description: 'Gestión de proyectos y gobierno IT.'
          }
        ]
      },
      experiences: {
        experiences: [
          {
            number: '1',
            description: 'Desde 1996 Izertis da servicio a empresas, instituciones y administraciones públicas. Izertis cuenta con más de 600 empleados y una facturación de más de 40 M€.'
          },
          {
            number: '2',
            description: 'Izertis posee oficinas en: <br> — España (Asturias, Pais Vasco, Madrid, Cataluña, Sevilla, Galicia, Valencia, Zaragoza y Las Palmas). <br> — Portugal: Aveiro, Oporto, Lisboa. <br> — Mexico: Mexico CDMX, Guadalajara y Monterrey. <br> — Costa Rica <br> — Colombia <br> — Perú'
          }
        ]
      },
      projects: [
        {
          title: 'Banco Africano de Desarrollo.',
          img: {
            src: 'assets/img/project-2.png',
            alt: 'Proyecto: 50 Million African Women Speak Platform.'
          },
          description:
            'Proyecto: 50 Million African Women Speak Platform.'
        },
        {
          title: 'EU- H2020.',
          img: {
            src: 'assets/img/project-1.png',
            alt: 'Proyecto: Natconsumers.'
          },
          description:
            'Proyecto: Natconsumers.'
        },
        {
          title: 'EU- ERANET-',
          img: {
            src: 'assets/img/project-3.png',
            alt: 'Proyecto DRESSING4SCARS'
          },
          description:
            'Proyecto DRESSING4SCARS'
        },
        {
          title: 'EU- MANUNET',
          img: {},
          description:
            'Proyecto: KBSWeld'
        }
      ],
      location: {
        url: 'https://www.google.es/maps/place/Izertis/@43.5257669,-5.6257932,17z/data=!4m8!1m2!2m1!1zUGFycXVlIGNpZW50w61maWNvIFRlY25vbMOzZ2ljbyBkZSBHaWrDs24sIEF2ZGEgZGVsIEphcmTDrW4gQm90w6FuaWNvLCAxMzQ1LCAzMzIwMywgR2lqw7NuLCBFc3Bhw7FhLg!3m4!1s0xd367b12db732933:0x81344eab962c6cb4!8m2!3d43.52625!4d-5.623813',
        img: {
          src: 'assets/img/maps/izertis-map.png',
          alt: 'texto alt'
        },
        adress: 'Parque científico Tecnológico de Gijón, Avda del Jardín Botánico, 1345, 33203, Gijón, España.'
      }
    }
  }
})
